var render = function render(){var _vm=this,_c=_vm._self._c;return _c('collapsed-card',{attrs:{"icon":"md-document","title":"Документы"}},[_c('resources-editor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }